
import { useState } from 'react';
import CommentsList from './CommentsList';
import CommentDetail from './CommentDetail';
import InboxHeader from './InboxHeader';
import EmptyState from './EmptyState';
import { useInboxComments } from './hooks/useInboxComments';

interface InboxViewProps {
  selectedProfiles: string[];
}

const InboxView = ({ selectedProfiles }: InboxViewProps) => {
  const [filterActive, setFilterActive] = useState(false);
  
  const {
    comments,
    selectedCommentId,
    isLoading,
    handleSelectComment,
    selectedComment
  } = useInboxComments(selectedProfiles);

  // Calculate the number of unread comments
  const unreadCount = comments.filter(c => !c.isRead).length;

  return (
    <div className="flex h-full overflow-hidden bg-white dark:bg-[#1a1d2d] dark:border-gray-700 transition-colors">
      <div className="w-2/5 border-r border-gray-200 dark:border-gray-700/50 flex flex-col">
        <InboxHeader 
          filterActive={filterActive} 
          setFilterActive={setFilterActive} 
          unreadCount={unreadCount}
        />
        
        {isLoading ? (
          <div className="flex items-center justify-center h-32">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-gray-500 dark:border-gray-400"></div>
          </div>
        ) : comments.length === 0 ? (
          <EmptyState 
            message="Aucun commentaire trouvé dans la base de données" 
            subMessage="Sélectionnez un autre profil" 
          />
        ) : (
          <CommentsList 
            comments={filterActive ? comments.filter(c => !c.isRead) : comments} 
            selectedCommentId={selectedCommentId} 
            onSelectComment={handleSelectComment} 
          />
        )}
      </div>
      
      <div className="flex-1 flex flex-col">
        <CommentDetail comment={selectedComment} />
      </div>
    </div>
  );
};

export default InboxView;
